export default "__VITE_ASSET__CBz6Mwl1__"